import { gql } from "apollo-boost";

export const COMMENTS_GET_MY = gql`
  query {
    getMyComments {
      results {
        id
        content
        url
        updated_at
      }
      count
    }
  }
`;

export const PROFILE_GET = gql`
  query($id: String!) {
    getProfile(id: $id) {
      introduction
      profession
      specialty
      gender
    }
  }
`;

export const PROFILE_UPDATE = gql`
  mutation($profile: UpdateProfileDto!) {
    updateProfile(updateProfileDto: $profile) {
      profession
      introduction
      gender
      specialty
    }
  }
`;

export const CURRENT_USER_DETAILED = gql`
  {
    getMe {
      username
      email
      avatarUrl
      roles {
        role
      }
      status
      id
      created_at
    }
  }
`;

export const REQUEST_VERIFICATION_EMAIL = gql`
  mutation($response: String!) {
    requestVerificationEmail(response: $response)
  }
`;

export const VERIFY_EMAIL = gql`
  mutation($id: String!) {
    verifyEmail(id: $id)
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation($update: UpdatePasswordDto!) {
    updatePassword(updatePasswordDto: $update)
  }
`;

export const GQL_SUB_HISTORY = gql`
  query($take: Int, $skip: Int) {
    getMySubscription(take: $take, skip: $skip) {
      count
      results {
        id
        updated_at
        public
        navi {
          params {
            term
          }
        }
      }
    }
  }
`;

export const GQL_SUB_TO_HISTORY = gql`
  query($take: Int, $skip: Int) {
    getMySubTo(take: $take, skip: $skip) {
      count
      results {
        updated_at
        naviSubscriberId
        navi {
          params {
            term
          }
        }
      }
    }
  }
`;

export const GET_ROCKET_KEY = gql`
  query {
    getRocketToken
  }
`;

export const GET_ACTIVITY_STATS = gql`
  {
    getPubmedSearchStats {
      count
      month
    }
    getNaviSearchStats {
      count
      month
    }
    getPaperViewedStats {
      count
      month
    }
  }
`;
